import { RefObject, useEffect } from 'react';

/**
 * Lässt alle [data-reveal]-Elemente unterhalb von rootRef beim Scrollen
 * einblenden (Styles: .reveal-init/.reveal-visible in index.css).
 * Respektiert prefers-reduced-motion.
 */
export function useReveal(rootRef: RefObject<HTMLElement>, deps: unknown[] = []) {
  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window) || !rootRef.current) return;

    const els = rootRef.current.querySelectorAll('[data-reveal]');
    els.forEach(el => el.classList.add('reveal-init'));
    const io = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('reveal-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
